var Elevatione = function() {};

$(document).ready(function(){
    Elevatione.handleGDPRBanner()
    Elevatione.addEvents()
})

Elevatione.addEvents = function () {

    $('.cart_icon').on('click', function(){ 
        var that = this
        $(that).find('.bag_icon').attr('src', '');
        $(that).find('.bag_icon').addClass('fa fa-spinner fa-spin');
        Elevatione.addToCart($(this).attr('variant_id'), 1, {}, function() {
            Elevatione.updateCartCount()
            $(that).find('.bag_icon').parent().attr('variant_id', ' ');
            $(that).find('.bag_icon').removeClass('fa fa-spinner fa-spin');
            $(that).find('.bag_icon').addClass('fa fa-check-circle');
            // logic to change add to cart icon to tick
        })
    })
}

Elevatione.handleGDPRBanner = function() {
    Elevatione.ipLocation = Elevatione.detectLocation()
    if (Elevatione.ipLocation.continent_code === 'EU' && (localStorage.getItem('elevatione-grpr') != "true" || localStorage.getItem('elevatione-grpr') == "false")) {
        $('.gdpr-banner').show()
        $(window).scrollTop(0)
    }
}

Elevatione.setGDPRCookie = function (cookie) {
    localStorage.setItem('elevatione-grpr', cookie)
    $('.gdpr-banner-commpliance').hide()
}

Elevatione.addToCart = function (variant_id, quantity, properties, callback=null) {
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            "id": variant_id,
            "quantity": quantity,
            "properties": properties
        },
        dataType: 'json',
        success: function() { 
            if (callback) {
                callback()
            }
        },
        error: function () {
            if (callback) {
                callback()
            }
        }
    });    
}

Elevatione.addToCartForm = function (data, callback=null) {
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() { 
            if (callback) {
                callback()
            }
        },
        error: function () {
            if (callback) {
                callback()
            }
        }
    });    
}




Elevatione.updateCartCount = function () {
    $.getJSON('/cart.js', function(cart) { 
        $(".num_count").each(function(){
            $(this).html(cart.item_count);
        });
    });
}

Elevatione.goToCart = function () {
    window.location.href = '/cart'
}

Array.prototype.getExactObj = function (nameKey, actualnamekey) {
    for (var i=0; i < this.length; i++) {
        if (this[i][actualnamekey] === nameKey) {
            return this[i];
        }
    }
}

Elevatione.detectLocation = function () {
    let request = new XMLHttpRequest();
    request.open('GET', 'https://api.ipdata.co/?api-key=1fd3fb0ffdc7f6a0b091f53f7d42d130ab3a0ef042ab3f6f8b3c99e1', false);
    request.setRequestHeader('Accept', 'application/json');
    request.send();
    return JSON.parse(request.responseText)
}

Elevatione.getUrlParameter = function (sParam, default_param) {
    var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;    
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return default_param
};
